import { render, staticRenderFns } from "./learning.vue?vue&type=template&id=2a98a836&scoped=true&lang=pug"
import script from "./learning.vue?vue&type=script&lang=ts"
export * from "./learning.vue?vue&type=script&lang=ts"
import style0 from "./learning.vue?vue&type=style&index=0&id=2a98a836&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a98a836",
  null
  
)

export default component.exports